/** CMS section helpers — same rules as About.jsx for shared blocks. */

export const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

export const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

export const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

/** Payload for `AboutStartNewProject` from About page CMS (`page: "about"`). */
export const getAboutStartNewProjectContent = (aboutRoot) =>
  unwrapSectionData(
    findPageSection(aboutRoot || {}, "startanewproject") ||
      findPageSection(aboutRoot || {}, "aboutstartnewproject")
  );
